import moment from 'moment';
import 'parsleyjs'; // Parsleyjs is currently used by community post new / edit page and textBasedMixin for vue component

const setupParsleyLocale = (locale) => {
  const parsleyFileReference = locale.replace(/-/g, '_');

  return import(`parsleyjs/dist/i18n/${parsleyFileReference}`)
    .then(() => {
      window.Parsley.setLocale(locale);
    })
  ;
};

export default () => {
  let locale = I18n.currentLocale();
  locale = locale === 'zh' ? 'zh-tw' : locale;

  moment.locale(locale);

  setupParsleyLocale(locale);
};
